import { Component } from '@ecs/Component';

export class CarrierBay implements Component {
  readonly type = 'CarrierBay';

  constructor(
    public cooldown: number = 4500,
    public squadronSize: number = 2,
    public maxActive: number = 6,
    public lastLaunch: number = 0,
    public launchedIds: number[] = []
  ) {}
}
